/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PlantItem_lifeNode$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PlantList_viewer$ref: FragmentReference;
declare export opaque type PlantList_viewer$fragmentType: PlantList_viewer$ref;
export type PlantList_viewer = {|
  +allLifeNode: ?{|
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: PlantItem_lifeNode$ref,
      |}
    |}>,
  |},
  +$refType: PlantList_viewer$ref,
|};
export type PlantList_viewer$data = PlantList_viewer;
export type PlantList_viewer$key = {
  +$data?: PlantList_viewer$data,
  +$fragmentRefs: PlantList_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PlantList_viewer",
  "type": "Query",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "allLifeNode"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 30
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "edibles",
      "type": "Boolean",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "edibility",
      "type": "[Edibility]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "rank",
      "type": "[Rank]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "flowerColors",
      "type": "[String]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "leafType",
      "type": "[String]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "phyllotaxy",
      "type": "[String]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "flowerTypes",
      "type": "[String]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "fruitType",
      "type": "[String]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "growthHabit",
      "type": "[String]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "threatened",
      "type": "[String]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "allLifeNode",
      "name": "__ListLifeNode_allLifeNode_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "edibility",
          "variableName": "edibility"
        },
        {
          "kind": "Variable",
          "name": "edibles",
          "variableName": "edibles"
        },
        {
          "kind": "Variable",
          "name": "flowerColors",
          "variableName": "flowerColors"
        },
        {
          "kind": "Variable",
          "name": "flowerTypes",
          "variableName": "flowerTypes"
        },
        {
          "kind": "Variable",
          "name": "fruitType",
          "variableName": "fruitType"
        },
        {
          "kind": "Variable",
          "name": "growthHabit",
          "variableName": "growthHabit"
        },
        {
          "kind": "Variable",
          "name": "leafType",
          "variableName": "leafType"
        },
        {
          "kind": "Variable",
          "name": "phyllotaxy",
          "variableName": "phyllotaxy"
        },
        {
          "kind": "Variable",
          "name": "rank",
          "variableName": "rank"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "threatened",
          "variableName": "threatened"
        }
      ],
      "concreteType": "LifeNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "LifeNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "LifeNode",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "PlantItem_lifeNode",
                  "args": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6224b85c3a13baa56f66266a49d4db5e';
module.exports = node;
